<template>
	<div>
		<div class="text-center" v-if="loading>0">
			<b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
		</div>
		<b-alert show v-else-if="error" variant="danger" class="mb-3">{{error?.error||error}}</b-alert>
		<b-form v-else-if="user" @submit.prevent="saveSettings()">
			<b-overlay :show="saving > 0" variant="dark">
				<b-card class="mb-3">
					<template title>
						<h4 class="card-title">Calls</h4>
					</template>
					<b-form-group label="Call service" description="The server your calls' guests connect to.">
						<b-select v-model="user.call_service_id" :options="[ { id: null, name: 'None' }, ...call_services ]" value-field="id" text-field="name"></b-select>
					</b-form-group>
					<b-alert :show="!!saveError" variant="danger" class="mb-3">{{saveError&&(saveError.error||saveError.toString())}}</b-alert>
					<div class="text-center mt-3">
						<b-button variant="primary" type="submit">Save settings</b-button>
					</div>
				</b-card>
			</b-overlay>
		</b-form>
	</div>
</template>

<script>
export default {
	data() { return {
		loading: 0,
		error: null,
		saving: 0,
		saveError: null,
		user: null,
		call_services: [],
	}},
	async mounted() {
		try {
			this.loading++;
			await this.load();
		} catch(e) {
			console.error(e);
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async load() {
			this.call_services = await this.$api.get('calls/services');
			this.user = { ...this.$parent.$parent.user };
		},
		async saveSettings() {
			try {
				this.saveError = null;
				this.saving++;
				await this.$api.post('userData', {
					call_service_id: this.user.call_service_id,
				});
				await this.$parent.$parent.loadUserData();
				await this.load();
			} catch(e) {
				console.error(e);
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
	},
};
</script>
